import { render, staticRenderFns } from "./bookmakersettings.vue?vue&type=template&id=4c4e8fac&scoped=true"
import script from "./bookmakersettings.vue?vue&type=script&lang=js"
export * from "./bookmakersettings.vue?vue&type=script&lang=js"
import style0 from "./bookmakersettings.vue?vue&type=style&index=0&id=4c4e8fac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4e8fac",
  null
  
)

export default component.exports